<template>
    <div id="manual">
        <div class="manu">
            <h2 class="titu">Documental: Prevención de Riesgos Escénicos por CM<br>El Canal de la Música</h2>
            <div class="notiTex">
                <p class="tex"><span class="remarca">El 1 de enero de 2018 se presentó el documental realizado junto a INAMU en CM - El canal de la música.</span></p>
                <p class="tex">Prevención de Riesgos Escénicos, un audiovisual con entrevistas e información sobre optimización de circuitos eléctricos, seguridad general y condiciones de protección necesarias para prevenir accidentes en los escenarios.</p>
                <iframe width="80%" height="350px" src="https://www.youtube.com/embed/h5i4nhrEmvM?rel=0" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe><br>
                <p class="tex firma">Secretaría de prensa y difusión</p>
            </div>
        </div>
        <div class="manu">
            <h2 class="titu">Seguimos presentando el "Manual de prevención de riesgos escénicos" junto a INAMU</h2>
            <div class="notiTex">
                <p class="tex">Acompañanos en las provincias de Río Negro, Santa Fé y Entre Ríos.</p>
                <p class="tex">"La música no es peligrosa" son las condiciones riesgosas en las que a veces se desarrolla.</p>
                <p class="tex">Nuestro Secretario General, <span class="remarca">Gerardo "Pati" Bacalini</span> junto a Gabriel Soriano y Diego Boris, presidente de <span class="remarca">INAMU</span> estuvieron junto a músicos, técnicos y productores por más escenarios y lugares seguros en todo el pais.</p>

                <img class="foto" src="../assets/manual/presentacion_manual.jpg">
                
                <p class="tex"><span class="remarca">Acompañá y apoyá a tu asociación sindical. Seguí todas las actividades en <a class="alink" href="https://www.facebook.com/SATE.nacional" target="_blank">Facebook</a> y <a class="alink" href="https://twitter.com/SATE_oficial" target="_blank">X (Twitter)</a>.</span></p>
                <p class="tex firma">Secretaría de prensa y difusión</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
#manual{
    width: 100%;
    margin: 50px auto;
    max-width: 1200px;

    .manu{
        width: 90%;
        margin:  50px auto 100px;
        @media screen and (max-width: 400px) {
            width: 95%;
        }
        .titu{
            width: 90%;
            font-size: 2rem;
            margin: 0 auto 30px;
            padding: 20px;
            color: var(--white);
            // border-bottom: 2px solid var(--sate);
            background-color: var(--sate);
            @media screen and (max-width: 400px) {
                width: 95%;
                font-size: 1.6rem;
                padding: 20px 5px;
            }
        }
        .notiTex{
            width: 90%;
            text-align: center;
            margin: auto;
            .tex{
                text-align: left;
                margin: 5px auto;
                .remarca{
                    font-weight: 700;
                }
                a{
                    font-family: var(--sans);
                    color: var(--sate);
                    text-decoration: none;
                    font-weight: 500;
                    transition: all .3s ease;

                    &:hover{
                        text-decoration: underline;
                    }
                }
            }
            .foto{
                width: 100%;
                margin: 30px auto 10px; 
            }
            iframe{
                width: 100%;
                margin: 30px auto;
            }
        }
    }
}
</style>